import { Currency } from '../../model'
import { LiquidityState } from './useAddLiquidity'

export function getButtonState(state: LiquidityState, first?: Currency, second?: Currency) {
  switch (state) {
    case LiquidityState.WALLET_NOT_CONNECTED:
      return { text: 'Connect Wallet', error: false, disabled: false }
    case LiquidityState.INSUFFICIENT_BOTH_BALANCES:
      return { text: `Insufficient balances`, error: true, disabled: true }
    case LiquidityState.INSUFFICIENT_FIRST_BALANCE:
      return { text: `Insufficient ${first?.symbol} balance`, error: true, disabled: true }
    case LiquidityState.INSUFFICIENT_SECOND_BALANCE:
      return { text: `Insufficient ${second?.symbol} balance`, error: true, disabled: true }
    case LiquidityState.TOKEN_NOT_SELECTED:
      return { text: 'Select a token', error: false, disabled: true }
    case LiquidityState.PAIR_DOES_NOT_EXIST:
      return { text: 'Pair does not exist', error: true, disabled: true }
    case LiquidityState.TOKEN0_ABSOLUTE_LIMIT:
    case LiquidityState.TOKEN0_RELATIVE_LIMIT:
    case LiquidityState.TOKEN1_ABSOLUTE_LIMIT:
    case LiquidityState.TOKEN1_RELATIVE_LIMIT:
      return { text: 'Trade size too big', error: true, disabled: true }
    case LiquidityState.LOADING:
    case LiquidityState.NEED_BOTH_APPROVALS:
    case LiquidityState.NEED_FIRST_APPROVAL:
    case LiquidityState.NEED_SECOND_APPROVAL:
    case LiquidityState.MISSING_INPUT:
      return { text: 'Add liquidity', error: false, disabled: true }
    case LiquidityState.EMPTY:
      return { text: 'Add initial liquidity', error: false, disabled: false }
    case LiquidityState.INSUFFICIENT_FIRST_RESERVE:
      return { text: `Insufficient ${first?.symbol} liquidity`, error: true, disabled: true }
    case LiquidityState.INSUFFICIENT_SECOND_RESERVE:
      return { text: `Insufficient ${second?.symbol} liquidity`, error: true, disabled: true }
    default:
      return { text: 'Add liquidity', error: false, disabled: false }
  }
}
